import React, { Component } from "react";
import PropTypes from "prop-types";
import TramQTModal from "../../../../routes/BaoVeMoiTruong/TramQuanTrac/Modal/index"
import TramQTModal_DTM from "../../../../routes/DTM/TramQuanTrac/Modal"
class DNBCModal extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  componentDidMount() {

  }


  render() {
    const { handleAdd, handleCancel, selectedRow, isEdit, user, mode, phanloai } = this.props
    return (
      <div>
        {phanloai === "BVMT" &&
          <TramQTModal
            handleAdd={handleAdd}
            handleCloseModal={handleCancel}
            selectedRow={selectedRow}
            isEdit={isEdit}
            user={user}
            mode={mode}
            dulieu={true}
          />}
        {phanloai === "DTM" &&
          <TramQTModal_DTM
            handleAdd={handleAdd}
            handleCloseModal={handleCancel}
            selectedRow={selectedRow}
            isEdit={isEdit}
            user={user}
            mode={mode}
            dulieu={true}
          />}
      </div>
    );
  }
}

DNBCModal.propTypes = {
  handleAddAccount: PropTypes.func.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
  isEdit: PropTypes.bool
};

export default DNBCModal;
